import { render, staticRenderFns } from "./LdHowItWorks.vue?vue&type=template&id=1a376410&lang=pug"
import script from "./LdHowItWorks.vue?vue&type=script&lang=js"
export * from "./LdHowItWorks.vue?vue&type=script&lang=js"
import style0 from "./LdHowItWorks.vue?vue&type=style&index=0&id=1a376410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports